import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';
import GtmAddToBasketDelegatorInstance from './gtmAddToBasketDelegator';

class GtmBundleAddToBasketDelegator {
	constructor() {
		this.type = GtmTrackingType.BUNDLE_ADD_TO_BASKET;
		this.dataMapper = GtmAddToBasketDelegatorInstance.dataMapper;
		this.actionType = 'pdp_bundle';
	}

	getTrackingData(target, data) {
		const products = this.getAddedProducts(data);

		if (products.length) {
			return {
				event: 'addToCart',
				ecommerce: {
					add: {
						actionField: {
							list: TrackingHelperInstance.generateActionFieldString(),
							action_type: this.actionType,
						},
						products: products.map((product, index) =>
							TrackingHelperInstance.mapDataViaGtmKey(
								product,
								this.dataMapper,
								true,
								index + 1,
							),
						),
					},
				},
			};
		}
	}

	getAddedProducts(data) {
		return data && data.addToCart instanceof Array
			? data.addToCart.filter(product => Number(product.skuQty) > 0)
			: [];
	}
}

const GtmBundleAddToBasketDelegatorInstance =
	new GtmBundleAddToBasketDelegator();

export default GtmBundleAddToBasketDelegatorInstance;

// for test purpose only
export const GtmBundleAddToBasketDelegatorClass = GtmBundleAddToBasketDelegator;
